<template>

    
  
  <div xs12 sm10 md4 offset-md3 offset-sm2 style="height:100vh; width:100%; max-width:100%;" v-bind:class="{'pa-0 ma-0 background-container' : getScreenWidth() < 900, ' background-container-md' : getScreenWidth() > 900} ">

        <v-layout justify-center style="width:100%">
           
                <h4 style="color:grey" class="">Sign Up</h4>
            
            </v-layout>

          <v-layout justify-center>
          <v-flex   class="ml-2 mr-2" sm8 md4 >
              <v-layout justify-center elevation-2 style="background-color:white;border-radius:2px;">
                 
                  <form style="    width: 94%;">
                  
       <p v-if="errorMessage != ''" class="mt-4 caption red--text text--darken-4">{{errorMessage}}</p>
                      <v-text-field
              name="input-1"
              :label="gLang[lang].myAccount.username"
              v-model="name"
              id="testing"
              :error-messages="nameErrors"
    
  
      @input="$v.name.$touch()"
      @blur="$v.name.$touch()"
      
      required
            ></v-text-field>

                <v-text-field
                class=""
                  label="E-mail"
                  v-model="email" 
                  :error-messages="emailErrors"
                  @input="$v.email.$touch()"
                   @blur="$v.email.$touch()"
                     @keydown="errorMessage=''"
                  required
                ></v-text-field>

                      <v-text-field
              name="input-10-1"
              :label="gLang[lang].myAccount.password"
              type="password"
              v-model="password"
              :error-messages="passwordErrors"
                  @input="$v.password.$touch()"
                   @blur="$v.password.$touch()"
                  required
            ></v-text-field>
            <v-text-field
              name="input-10-1"
              :label="gLang[lang].myAccount.repeatPassword"
              type="password"
              v-model="repeatPassword"
              :error-messages="repeatPasswordErrors"
                  @input="$v.repeatPassword.$touch()"
                   @blur="$v.repeatPassword.$touch()"
                  required
            ></v-text-field>

            <v-checkbox
                :label="gLang[lang].signIn.termaConditionsAccept"
                v-model="checkbox"
           
                required

                :error-messages="checkboxErrors"
    
  
      @input="$v.checkbox.$touch()"
      @blur="$v.checkbox.$touch()"
                 ></v-checkbox>
            
            <v-layout row >
                   <v-btn style="width:215px;"
                                        color="primary"
                                        v-bind:class="{ 'green darken-3' : status }"
                                        :loading="loading"
                                        @click="clickInputMain()"
                                        >{{gLang[lang].myAccount.profileImage}}
                                        <v-icon right dark>
                                            cloud_upload
                                        </v-icon>
                                 </v-btn>
                                                                  <form enctype="multipart/form-data" novalidate v-if="isInitial || isSaving || isSuccess">
                                <input type="file"  name="avatar" style="display:none" :disabled="isSaving" @change="filesChange($event.target.name, $event.target.files, -1); fileCount = $event.target.files.length" accept="image/*" class="input-file" ref="fileInput1">
                                </form>
    <v-spacer></v-spacer>
                                <v-btn dark class="red "  :disabled="loading" @click="submit">
                     Sign up
                 </v-btn>
            </v-layout>
            
            
            
                  </form>
              </v-layout>

              <v-layout row justify-center class="mt-3">
                    <!-- <v-checkbox
                label="Remember me"
                v-model="checkbox"
                 ></v-checkbox> --> 
                 <!-- <v-btn dark class="red "  :disabled="loading" @click="submit">
                     Sign up
                 </v-btn> -->
            </v-layout>
 
          </v-flex>
          </v-layout>

          <v-flex xs10 offset-xs1 sm6 offset-sm3 class="mt-3">
            <v-layout row justify-center>
                <a class="terms "  href="">Terms And Conditions &nbsp;</a> <br>
                <p class="terms">|</p>
                <a class="terms"  href=""> &nbsp; Privacy Policy</a>
            </v-layout>
            <v-layout row justify-center>
                <p class="terms ">LOGO ©2017</p>

            </v-layout>

        </v-flex>


      <v-layout justify-center>
            <v-flex xs10  sm6 md3  class="mt-3">
              <!-- <v-layout   justify-center>
                  <v-btn style="width:100%"  class="primary"  @click="register">
                      <v-icon left style="">
                          mail 
                      </v-icon>
                      Create an account
                  </v-btn> -->
              
              <v-layout  justify-center>
                  <v-btn  @click="authenticate('facebook')" dark style="width:100%; background-color:#3b5998">
                      <!-- <v-icon left style="" class="fa-facebook" name="fa-facebook">
                          fa-facebook
                      </v-icon>
                      <icon name="fa-facebook"> </icon> --> <img src="../../../assets/facebook.png" class="socialImage mr-2" alt="">
                      {{gLang[lang].signIn.signInFb}}
                  </v-btn>
              </v-layout>
              <v-layout  justify-center>
                  <v-btn  @click="authenticate('google')"  dark style="width:100%; background-color: #dd4b39">
                      <img src="../../../assets/google.png" class="socialImage mr-2" alt="">
                      {{gLang[lang].signIn.signInG}}
                  </v-btn>
              </v-layout>
                   <v-layout  justify-center>
                  <v-btn  @click="authenticate('live')"  dark style="width:100%; background-color: #2672EC">
                      <img src="../../../assets/microsoft.png" class="socialImage mr-2" alt="">
                      {{gLang[lang].signIn.signInM}}
                  </v-btn>
              </v-layout>
          </v-flex>
      </v-layout>

          

        
<!-- 

  <web-dialog :dialog="dialog" @clicked="dialog = !dialog"></web-dialog> -->




  </div>    



</template>


<style scoped>
.terms {
  text-decoration: none;
  outline: none;
  /* white-space: nowrap; */
  color: grey !important;
  font-size: 0.75em;
  line-height: 1px;
}

.background-container {
  /* background-image: linear-gradient(to bottom right,#000000,#000000), url(../../assets/login_photo.jpeg); */

  /* background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(../../assets/login_photo.jpeg); */
  background-size: 100vw 100vh;
}

.background-container-md {
  padding-top: 4%;
}

.socialImage {
  width:20px;
}
</style>



<script>
import { Uploader } from "@/components/Mixins/fileUploader.js";
import { validationMixin } from 'vuelidate'
import { required, maxLength, minLength, email, sameAs, alpha, numeric } from 'vuelidate/lib/validators'
export default {

  mixins: [validationMixin,Uploader],
    validations: {
      name: { required, maxLength: maxLength(8) },
      email: { required, email },
      select: { required },
      checkbox: { required },
      password: { required, minLength: minLength(8), alpha, numeric },
      repeatPassword: {required, sameAsPassword: sameAs('password')},
      
    },
  data() {
    return {
      errorMessage :'',
      register_boolean: true,
      e1: true,
      dialog: false,
      password: "",
      checkbox:false,
      repeatPassword:'',
      first: "John",
      email: "",
      name: "",
      picture:"",
      status:0,
      loading:false,
      checkboxRules : [ (v) => !!v || 'Name is required',]
      //rules: {
      //required: (value) => !!value || 'This field is required.',
      //email: (value) => {
      //const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      //return pattern.test(value) || 'Invalid e-mail.'
      //}
      //},

    };
  },
  methods: {
    submit() {
      this.$v.$touch();
      this.emailErrors.length == 0 && this.passwordErrors.length == 0 && this.repeatPasswordErrors.length == 0 && this.nameErrors.length == 0 && this.checkboxErrors.length ==0 && this.register();
    },

    authenticate: function (provider) {
      this.$auth.authenticate(provider).then((response) => {
        // Execute application logic after successful social authentication
        this.$store.dispatch("createToken", response.data.token);
        this.$store.dispatch("getSocialUser",response.data.token)
        console.log(response)
        this.$router.push("/")
           }).catch((err)=>{
             console.log(err)
           })
    },
    login: function() {
      this.$auth
        .login({ email: this.email, password: this.password })
        .then(token => {
          this.$store.dispatch("createToken", token.data.token);
          this.$store.dispatch("createUser", token.data.user);
          this.$router.push("/");
        })
        .catch(err => {
          console.log(err);
        });
    },

    register: function() {
      this.$auth
        .register({
          displayName: this.name,
          email: this.email,
          password: this.password,
          picture: this.picture
        })
        .then(token => {
          this.$store.dispatch("createToken", token.data.token);
          this.$store.dispatch("createUser", token.data.user);
          this.$router.push("/");
        })
        .catch(err => {
          this.errorMessage = "Email already in use!"
        });
    },
    onCreateToken() {
      this.$store.dispatch("createToken", this.formUpload);
      this.$router.push("/artefacts");
    },
    isAuthenticated() {
      if (token != "") return true;
      return false;
    },
    getScreenWidth() {
      return screen.width;
      console.log(screen.width);
      console.log(screen.availWidth);
      console.log(screen.systemXDPI);
    }
  },
  mounted () {
     document.title = "Sign Up";
    window.scrollTo(0, 0);
  },
  computed: {
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    },
    nameErrors () {
        const errors = []
        if (!this.$v.name.$dirty) return errors
        // !this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')
        !this.$v.name.required && errors.push('Username is required.')
        return errors
      },
       checkboxErrors () {
        const errors = []
        if (!this.$v.checkbox.$dirty) return errors
        // !this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')
        !this.$v.checkbox.required && errors.push('You have to accept the Terms and Conditions.')
        return errors
      },
      passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.minLength && errors.push("Must be at least 8 characters");
      !this.$v.password.required && errors.push("Password is required");
      this.$v.password.alpha  && errors.push("Should have at least one number");
      this.$v.password.numeric  && errors.push("Should have at least one letter");
      return errors;
    },
    repeatPasswordErrors() {
      const errors = [];
      if (!this.$v.repeatPassword.$dirty) return errors;
      !this.$v.repeatPassword.sameAsPassword && errors.push("Must match the first password");
      !this.$v.repeatPassword.required && errors.push("Password is required");
      return errors;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    }
  },
  created() {
    if (this.isLoggedIn) {
      this.$router.push("/");
    }
  },
  
};
</script>


// WEBPACK FOOTER //
// src/components/Presentation/User/SignUp.vue